import { yupResolver } from '@hookform/resolvers/yup';
import { MIN_WITHDRAW_PAYPAL_AMOUNTS, SystemCurrency } from '@okletsplay/core';
import { useForm, UseFormReturn } from 'react-hook-form';
import { WithdrawFundsFields } from '../interfaces';
import { buildWithdrawRequestFormSchema } from './withdraw-request-form-schema';

export type WithdrawRequestFields = WithdrawFundsFields & {
  destinationEmail: string;
  isEmailConfirmed: boolean;
  country: string;
};

interface UseWithdrawFormHook {
  form: UseFormReturn<WithdrawRequestFields>;
}

export const useWithdrawRequestForm = (
  userCountryCode: string | undefined,
  userEmail: string | undefined,
  ...rest: Parameters<typeof buildWithdrawRequestFormSchema>
): UseWithdrawFormHook => {
  const formResolver = yupResolver(buildWithdrawRequestFormSchema(...rest));

  const form = useForm<WithdrawRequestFields>({
    mode: 'onChange',
    resolver: formResolver,
    defaultValues: {
      amount: 0,
      currency: Object.keys(MIN_WITHDRAW_PAYPAL_AMOUNTS)[0] as SystemCurrency,
      destinationEmail: userEmail,
      isEmailConfirmed: false,
      country: userCountryCode,
    },
  });

  return { form };
};
